import { IArticle, ICreateArticle, IUpdateArticle } from "../models/article.ts";
import { ILazyAttachment } from "../models/zip_content.ts";
import { ImportProgressStatus } from "../modules/parts/ImportProgressModal.tsx";
import { getArticleAttachments } from "../lib/api/articleAttachments/getArticleAttachments.ts";
import { uploadArticleAttachments } from "../lib/api/articleAttachments/uploadArticleAttachments.ts";
import { IArticleAttachment } from "../models/articleAttachment.ts";
import { deleteArticleAttachment } from "../lib/api/articleAttachments/deleteArticleAttachment.ts";
import { CancelManager } from "../lib/cancelManager.ts";

export const handleAttachments = async (
  token: string,
  brandUrl: string,
  postedArticle: IArticle,
  article: ICreateArticle | IUpdateArticle,
  attachments: ILazyAttachment[],
  onUpdateProgressInfo: (
    status: ImportProgressStatus,
    message: string,
    link: string,
  ) => void,
) => {
  const cancelManager = CancelManager.getInstance();
  cancelManager.checkCancelled();

  onUpdateProgressInfo("Import", "", postedArticle.html_url);

  if ("id" in article) {
    const articleAttachments = await getArticleAttachments(
      token,
      brandUrl,
      article.id,
    );
    await deleteExistingAttachments(
      token,
      brandUrl,
      articleAttachments.filter((a) => !a.inline),
    );
  }
  cancelManager.checkCancelled();
  await uploadArticleAttachments(
    token,
    brandUrl,
    postedArticle.id,
    article,
    attachments,
  );
};

const deleteExistingAttachments = async (
  token: string,
  brandUrl: string,
  attachments: IArticleAttachment[],
) => {
  const cancelManager = CancelManager.getInstance();

  for (const attachment of attachments) {
    cancelManager.checkCancelled();
    await deleteArticleAttachment(token, brandUrl, attachment.id);
  }
};
